import { ChevronRightRounded } from '@mui/icons-material'
import { TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab'
import { Box, Breadcrumbs, useTheme } from '@mui/material'
import { useMemo } from 'react'
import useStyles from '~/common/hooks/useStyles'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import Link from '~/components/shared/Link'
import { Button } from '~/components/ui/atoms/button/Button'
import { getActivityItemProps } from '../../../common/utils/event'
import { UserAvatar } from '../../users/UserAvatar'
import { PaginatedComment, PaginatedEvent, PaginatedNotificationEvent } from '../types'
import { ActivityItemHeader } from './ActivityItemHeader'
import { ActivityEventItemType, getDossActivityTimelineStyles } from './ActivityTimeline'

export interface ActivityItemProps {
  activity: PaginatedEvent | PaginatedComment | PaginatedNotificationEvent
}
export function ActivityItem({ activity }: ActivityItemProps) {
  const styles = useStyles(getDossActivityTimelineStyles)
  const theme = useTheme()
  const { t } = useTypedTranslation()

  const { action, author, breadcrumbs, details, icon, time, type, user } = useMemo(
    () => getActivityItemProps(t, activity, styles, theme),
    [t, activity, styles, theme],
  )

  const iconComponent =
    type === ActivityEventItemType.COMMENT && author ? (
      <UserAvatar user={author} />
    ) : (
      <Box sx={styles.icon}>{icon}</Box>
    )

  return (
    <TimelineItem sx={styles.item}>
      <TimelineSeparator sx={styles.separator}>{iconComponent}</TimelineSeparator>
      <TimelineContent sx={styles.content}>
        <div className="py-1.5">
          <ActivityItemHeader action={action} name={user} time={time} type={type} />
        </div>
        {type !== ActivityEventItemType.COMMENT && (
          <Box sx={styles.breadcrumbs}>
            <Breadcrumbs separator={<ChevronRightRounded fontSize="small" />}>
              {breadcrumbs.map((breadcrumb, index) =>
                breadcrumb.link ? (
                  <Button
                    key={index}
                    component={Link}
                    href={breadcrumb.link}
                    size="small"
                    variant={'ghost'}
                  >
                    {breadcrumb.name}
                  </Button>
                ) : (
                  <Button key={index} disabled size="small" variant={'ghost'}>
                    {breadcrumb.name}
                  </Button>
                ),
              )}
            </Breadcrumbs>
          </Box>
        )}
        <Box sx={styles.details}>{details}</Box>
      </TimelineContent>
    </TimelineItem>
  )
}
